import React from 'react'
import styles from './iconStyles.module.scss'

export default function FaFolderOpen() {
  return (
    <div className={styles.FaFolderOpen} />
  )
}
